var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseTableView',{class:_vm.extra && _vm.$vuetify.breakpoint.xlOnly ? 'table--extra' : 'table--main',attrs:{"head":_vm.tableHead}},_vm._l((_vm.periods),function(period,key){return _c('TimeControlShowEmployeeTableCurentDateItem',{key:key,attrs:{"period":period,"extra":_vm.extra}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }